import { gql } from '@apollo/client';
import Fragments from './fragments';

export const USER_LIST_QUERY = gql`
  query userList {
    userList {
      userId
      userName
      firstName
      lastName
    }
  }
`;

export const USER_GROUP_QUERY = gql`
  query userGroup($userGroupId: Int!) {
    userGroup(userGroupId: $userGroupId) {
      ...userGroup
    }
  }
  ${Fragments.userGroup}
`;

export const USER_X_GROUP_QUERY = gql`
  query userXGroup($userGroupId: Int!) {
    userXGroup(userGroupId: $userGroupId)
  }
`;
